<div class="modal">
    <div class="header">
        <div class="smash-logo">
            <ng-container *ngIf="logo && isPremium; else noLogo">

                <div class="smash-spinner-logo" [appBackgroundImage]="logo.sourceUrl"></div>

            </ng-container>
            <ng-template #noLogo>
                <i class="icon-smash_icologo_chip"></i>
            </ng-template>
        </div>
        <div class="title title-big" translate>VIEWER_MODAL_PREVIEW_ACCESS_TRACKING_TITLE</div>
    </div>

    <div class="body">
        <div class="section">
            <p class="description"
                [innerHtml]="'VIEWER_MODAL_PREVIEW_ACCESS_TRACKING_DESCRIPTION' | translate | safeHtml"></p>
        </div>
        <div class="section">
            <form class="form-section" [formGroup]="accessTrackingForm" (ngSubmit)="onSubmit()">
                <div class="form-input">
                    <app-smash-input type="email"
                        autocomplete="email"
                        placeholder="{{ 'VIEWER_MODAL_PREVIEW_ACCESS_TRACKING_PLACEHOLDER' | translate }}"
                        formControlName="accessTracking" borderStyle="full">
                        <div *ngIf="(unlockError$ | async)"
                            [innerHtml]="'VIEWER_MODAL_PREVIEW_ACCESS_TRACKING_ERROR_MESSAGE' | translate | safeHtml"
                            error>
                        </div>
                    </app-smash-input>
                </div>
            </form>
        </div>
    </div>
    <div class="footer">
        <button type="submit" [disabled]="!accessTrackingForm.valid || (unlockLoading$ | async)"
            class="btn-new auto red" (click)="onSubmit()"
            translate>VIEWER_MODAL_PREVIEW_ACCESS_TRACKING_BUTTON_ENTER_LABEL</button>
    </div>
    <div *ngIf="(unlockLoading$ | async)" class="spinner-container-overlay">
        <div class="loading-spinner-grey"></div>
    </div>

</div>
<div class="hack-smash-logo">
    <app-smash-header *ngIf="device?.isDesktop" [showMenu]="true" (goToUploader)="onGoToUploader()"
        (menuToggle)="onToggleMenu($event)" [selectedTeam]="selectedTeam$ | async" [isLoggedIn]="hasToken$ | async"
        [state]="menuDisplayed$ | async">
    </app-smash-header>
</div>